var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.812,32.561h-27.72H24.188c-1.104,0-2,0.896-2,2v8.907v0.08v8.906v8.986c0,1.104,0.896,2,2,2s2-0.896,2-2v-6.986h17.903 c1.104,0,2-0.896,2-2v-8.906c0-0.014-0.004-0.026-0.004-0.04c0-0.014,0.004-0.026,0.004-0.04v-6.907h23.72v24.879 c0,1.104,0.896,2,2,2s2-0.896,2-2V34.561C73.812,33.456,72.916,32.561,71.812,32.561z M42.091,50.453H26.188v-4.906h15.903V50.453z  M42.091,41.467H26.188v-4.907h15.903V41.467z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.14,
    cy: 48,
    r: 1.822
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.14,40.836c1.005,0,1.822-0.817,1.822-1.822c0-1.005-0.817-1.822-1.822-1.822s-1.822,0.817-1.822,1.822 C32.318,40.019,33.135,40.836,34.14,40.836z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.161576a7081406758a526a18ad91cb6c.svg";
export { ForwardRef as ReactComponent };